import "core-js/modules/es6.array.some";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import { stringValue } from 'vega-util';
import { FACET_CHANNELS } from '../../channel';
import { SELECTION_ID } from '../../selection';
import { vals } from '../../util';
import { isFacetModel } from '../model';
import interval from './interval';
import multi from './multi';
import single from './single';
export var STORE = '_store';
export var TUPLE = '_tuple';
export var MODIFY = '_modify';
export var SELECTION_DOMAIN = '_selection_domain_';
export var VL_SELECTION_RESOLVE = 'vlSelectionResolve';
var compilers = {
  single: single,
  multi: multi,
  interval: interval
};
export function forEachSelection(model, cb) {
  var selections = model.component.selection;

  if (selections) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = vals(selections)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var sel = _step.value;
        var success = cb(sel, compilers[sel.type]);
        if (success === true) break;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}

function getFacetModel(model) {
  var parent = model.parent;

  while (parent) {
    if (isFacetModel(parent)) {
      break;
    }

    parent = parent.parent;
  }

  return parent;
}

export function unitName(model) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    escape: true
  },
      escape = _ref.escape;

  var name = escape ? stringValue(model.name) : model.name;
  var facetModel = getFacetModel(model);

  if (facetModel) {
    var facet = facetModel.facet;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = FACET_CHANNELS[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var channel = _step2.value;

        if (facet[channel]) {
          name += " + '__facet_".concat(channel, "_' + (facet[").concat(stringValue(facetModel.vgField(channel)), "])");
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return name;
}
export function requiresSelectionId(model) {
  var identifier = false;
  forEachSelection(model, function (selCmpt) {
    identifier = identifier || selCmpt.project.items.some(function (proj) {
      return proj.field === SELECTION_ID;
    });
  });
  return identifier;
}